<template>
  <div class="consultingHome">
    <baseBg bgUrl="consultingbg"></baseBg>
    <div class="aboutHomeNav w-main">
      <span :class="{ spanAct: pageType === 'page1' }" @click="toPage('page1')">
        技术咨询
      </span>
      <span :class="{ spanAct: pageType === 'page2' }" @click="toPage('page2')">
        高级职称申报
      </span>
      <span :class="{ spanAct: pageType === 'page3' }" @click="toPage('page3')">
        磁罗经分部
      </span>
    </div>
    <div class="line w-main"></div>
    <div class="he50"></div>
    <component :is="pageType"></component>
    <div class="he50"></div>
    <div class="he50"></div>
  </div>
</template>

<script>
import baseBg from "@/components/pc/base/bg.vue";
import page1 from "./pages/page1";
import page2 from "./pages/page2";
import page3 from "./pages/page3";
// import page4 from "./pages/page4";
// import page5 from "./pages/page5";
// import page6 from "./pages/page6";
export default {
  data() {
    return {
      pageType: "page1"
    };
  },
  components: {
    baseBg,
    page1,
    page2,
    page3
  },
  watch: {
    $route(newValue) {
      this.toPage(newValue.query.pages);
    }
  },
  mounted() {
    this.toPage(this.$route.query.pages);
  },
  methods: {
    toPage(val) {
      if (val) {
        this.pageType = val;
      } else {
        this.pageType = "page1";
      }
    }
  }
};
</script>

<style lang="less">
.consultingHome {
  .aboutHomeNav {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    span {
      display: inline-block;
      margin: 0 30px;
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      font-weight: bold;
      color: rgba(52, 52, 52, 1);
      cursor: pointer;
    }
    .spanAct {
      color: rgba(108, 45, 102, 1);
      border-bottom: 2px solid #6c2c66;
    }
  }
  .line {
    height: 1px;
    background: rgba(235, 235, 235, 1);
  }
  .img-box {
    display: flex;
    justify-content: space-between;
    // align-items: flex-start;
    .item2-img {
      text-align: center;
      img {
        margin-bottom: 20px;
      }
      p {
        font-size: 18px;
        font-weight: bold;
        color: rgba(52, 52, 52, 1);
        line-height: 24px;
      }
    }
  }
  .item2 {
    padding: 30px 0;
    background: rgba(247, 248, 250, 1);
    .item-img {
      text-align: center;
    }
  }
  .item3 {
    padding: 60px 40px;
    box-sizing: border-box;
    background: rgba(22, 81, 148, 1);
    box-shadow: 0px 10px 26px 0px rgba(17, 25, 34, 0.24);
    border-radius: 10px;
    .item3-title {
      font-size: 24px;
      font-family: PingFang;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
    }
    .item3-text {
      font-size: 16px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 24px;
    }
  }
  .item3-box {
    display: flex;
    justify-content: space-between;
    .list {
      width: 48%;
      .list-title {
        margin-bottom: 20px;
        font-size: 30px;
        font-weight: 400;
        color: rgba(52, 52, 52, 1);
      }
      .left-text {
        position: relative;
        width: 100%;
        margin-bottom: 10px;
        padding-left: 20px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(52, 52, 52, 1);
        line-height: 30px;
        box-sizing: border-box;
        .left-icon {
          position: absolute;
          left: 0;
          top: 10px;
          display: inline-block;
          width: 10px;
          height: 10px;
          background: rgba(22, 81, 148, 1);
          transform: rotate(45deg);
        }
      }
    }
  }
  .consulting-title {
    font-size: 50px;
    font-family: PingFang;
    font-weight: 400;
    color: rgba(52, 52, 52, 1);
    text-align: center;
  }
  .consulting-line {
    margin: 20px auto;
    width: 90px;
    height: 3px;
    background: rgba(108, 44, 102, 1);
  }
}
</style>
